import { inject } from '@angular/core';
import { type CanActivateFn } from '@angular/router';
import { map, of, type Observable } from 'rxjs';
import { Role } from '@/core/models/auth.interface';
import { GenericProfileService } from '@/shared/services/profile.service';
import { UserProfileService } from '@/pages/user-profile/user-profile.service';

/**
 * After client login, preloads deal preferences and sets the first unanswered question
 * for the prompt dialog. Skipped on page refresh (login flow must call markDealPreferencesPromptForLogin).
 */
export const dealPreferencesPromptGuard: CanActivateFn = (): Observable<boolean> => {
    const genericProfileService = inject(GenericProfileService);
    const userProfileService = inject(UserProfileService);

    if (genericProfileService.genericProfile()?.role !== Role.CLIENT) {
        return of(true);
    }

    return userProfileService.ensureCategoryPreferencesForPrompt().pipe(map(() => true));
};
